export default __webpack_public_path__ + "178afa6030e76635dbe835e111d2c507.png";